// @flow

export const AUDIENCE_LIST_LOADING = 'LOAD_AUDIENCE_LIST'
export const AUDIENCE_LIST_LOADED = 'AUDIENCE_LIST_LOADED'
export const AUDIENCE_LIST_ERROR = 'AUDIENCE_LIST_ERROR'
export const AUDIENCE_LIST_RESET = 'AUDIENCE_LIST_RESET'
